import React from 'react';

const AboutUs1 = () => {
  return (
    <section className="template-about-us-1 py-5">
      <div className="container">
        <div className="row align-items-center">
          
          {/* Left Column: Text Content */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <h2 className="display-5 fw-bold section-title mb-3">Your Trusted Travel Partner</h2>
            <p className="text-muted">
              TravelEase was founded in 2010 with a simple mission: to make extraordinary travel experiences accessible to everyone. Over the years, we've helped thousands of travelers discover the world's most beautiful destinations.
            </p>
            <p className="text-muted">
              Our team of travel experts carefully curates each package, ensuring that every detail is taken care of. From luxury resorts to adventurous expeditions, we offer a wide range of options to suit every traveler's preferences.
            </p>
            
            {/* Stat Cards */}
            <div className="row mt-4">
              <div className="col-md-4">
                <div className="stat-card text-center p-3">
                  <h3 className="display-4 fw-bold stat-number text-primary">{/* ... */}</h3>
  <p className="text-muted">Years Experience</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="stat-card text-center p-3">
                  <h3 className="display-4 fw-bold stat-number">50+</h3>
                  <p className="text-muted">Destinations</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="stat-card text-center p-3">
                  <h3 className="display-4 fw-bold stat-number">10k+</h3>
                  <p className="text-muted">Happy Travelers</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="col-lg-6">
            <img 
              src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" 
              className="img-fluid rounded shadow-lg" 
              alt="Team working on laptops" 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs1;